var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_319_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.25 39.375H39.375V61.25C39.375 63.6562 37.415 65.625 35 65.625C32.585 65.625 30.625 63.6562 30.625 61.25V39.375H8.75C6.335 39.375 4.375 37.4062 4.375 35C4.375 32.5938 6.335 30.625 8.75 30.625H30.625V8.75C30.625 6.34375 32.585 4.375 35 4.375C37.415 4.375 39.375 6.34375 39.375 8.75V30.625H61.25C63.665 30.625 65.625 32.5938 65.625 35C65.625 37.4062 63.665 39.375 61.25 39.375ZM61.25 26.25H43.75V8.75C43.75 3.91562 39.8322 0 35 0C30.1678 0 26.25 3.91562 26.25 8.75V26.25H8.75C3.91781 26.25 0 30.1656 0 35C0 39.8344 3.91781 43.75 8.75 43.75H26.25V61.25C26.25 66.0844 30.1678 70 35 70C39.8322 70 43.75 66.0844 43.75 61.25V43.75H61.25C66.0822 43.75 70 39.8344 70 35C70 30.1656 66.0822 26.25 61.25 26.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_319_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusRound);
export default __webpack_public_path__ + "static/media/plusRound.0760947e876ac39e924abab0f114640f.svg";
export { ForwardRef as ReactComponent };